import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14.749 13.927a.743.743 0 0 1-.75.75H2.009a.75.75 0 0 1 0-1.5H14a.749.749 0 0 1 .749.75Zm-12.12-2.25c.05 0 .1-.01.15-.01l7-1.42a.75.75 0 0 0 .58-.58l.82-3.86.85-.85a.754.754 0 0 0 0-1.06.737.737 0 0 0-1.06 0l-1.01 1a.741.741 0 0 0-.2.38l-.77 3.59-4.07.83 2.49-2.48a.75.75 0 0 0-1.06-1.06l-2.49 2.48.83-4.07 3.59-.76a.737.737 0 0 0 .38-.2L9.669 2.6a.75.75 0 0 0-1.06-1.06l-.85.85-3.86.82a.75.75 0 0 0-.58.58l-1.4 6.87a.717.717 0 0 0 .71 1.017Z';
const draw24px =
  'M20.76,21.49H3.24a.75.75,0,1,1,0-1.5H20.76a.75.75,0,0,1,0,1.5ZM5.35,14.1l0,0v-.07Zm1.05,1,0,0,0,0ZM17.63,6.33a.75.75,0,0,0-1.06,0L15.1,7.8a.67.67,0,0,0-.2.38l-1.16,5.47L6.45,15.13l0,0,0,0h0l4.43-4.44A.75.75,0,1,0,9.82,9.63L5.39,14.06v.07l0,0,0,0L6.87,6.78l5.47-1.16a.75.75,0,0,0,.37-.2L14.19,4a.77.77,0,0,0,0-1.07.75.75,0,0,0-1.06,0L11.81,4.2,6.08,5.41A.72.72,0,0,0,5.5,6L3.42,16.21a.71.71,0,0,0,0,.29h0a.83.83,0,0,0,.08.22.41.41,0,0,1,0,.09.91.91,0,0,0,.21.18l.09.05a.73.73,0,0,0,.3.06H4.3L14.52,15a.75.75,0,0,0,.58-.58L16.32,8.7l1.31-1.31A.75.75,0,0,0,17.63,6.33ZM5.38,14.13v-.07l0,0Zm1,1,0,0,0,0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PenLineIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'penLine'),
) as IconWithRender;

PenLineIcon.displayName = 'PenLineIcon';
PenLineIcon.propTypes = Icon.propTypes;
PenLineIcon.renderIcon = (props) => <PenLineIcon {...props} />;
export default PenLineIcon;
